import * as React from 'react'

import { cn } from '@/lib/utils'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '~/client/src/shared/components/shadcn-ui/tooltip'

type ContentProps = React.ComponentProps<typeof TooltipContent>

interface IProps {
  children?: React.ReactNode
  content?: React.ReactNode
  className?: string
  disabled?: boolean
  side?: ContentProps['side']
  align?: ContentProps['align']
}

function isEmptyContent(content: React.ReactNode): boolean {
  return (
    content == null ||
    typeof content === 'boolean' ||
    (typeof content === 'string' && !content.trim())
  )
}

export default class TooltipWrapper extends React.Component<IProps> {
  public static defaultProps = {
    side: 'bottom',
  }

  public render() {
    const { children, content, className, disabled, side, align } = this.props

    return (
      <Tooltip
        disabled={disabled || isEmptyContent(content)}
        disableHoverablePopup
      >
        <TooltipTrigger
          render={<span className={cn('tw:inline-block', className)} />}
        >
          {children}
        </TooltipTrigger>
        <TooltipContent side={side} align={align}>
          {content}
        </TooltipContent>
      </Tooltip>
    )
  }
}
